export class NICEDialerScheduleSettings {
    isScheduled: boolean;
    sundayStartTime: string;
    sundayEndTime: string;
    sundayIsActive: boolean;
    mondayStartTime: string;
    mondayEndTime: string;
    mondayIsActive: boolean;
    tuesdayStartTime: string;
    tuesdayEndTime: string;
    tuesdayIsActive: boolean;
    wednesdayStartTime: string;
    wednesdayEndTime: string;
    wednesdayIsActive: boolean;
    thursdayStartTime: string;
    thursdayEndTime: string;
    thursdayIsActive: boolean;
    fridayStartTime: string;
    fridayEndTime: string;
    fridayIsActive: boolean;
    saturdayStartTime: string;
    saturdayEndTime: string;
    saturdayIsActive: boolean;

    constructor(jsonObject?) {
            this.isScheduled = jsonObject?.isScheduled || false;
            this.sundayStartTime = jsonObject?.sundayStartTime || '';
            this.sundayEndTime = jsonObject?.sundayEndTime || '';
            this.sundayIsActive = jsonObject?.sundayIsActive || false;
            this.mondayStartTime = jsonObject?.mondayStartTime || '';
            this.mondayEndTime = jsonObject?.mondayEndTime || '';
            this.mondayIsActive = jsonObject?.mondayIsActive || false;
            this.tuesdayStartTime = jsonObject?.tuesdayStartTime || '';
            this.tuesdayEndTime = jsonObject?.tuesdayEndTime || '';
            this.tuesdayIsActive = jsonObject?.tuesdayIsActive || false;
            this.wednesdayStartTime = jsonObject?.wednesdayStartTime || '';
            this.wednesdayEndTime = jsonObject?.wednesdayEndTime || '';
            this.wednesdayIsActive = jsonObject?.wednesdayIsActive || false;
            this.thursdayStartTime = jsonObject?.thursdayStartTime || '';
            this.thursdayEndTime = jsonObject?.thursdayEndTime || '';
            this.thursdayIsActive = jsonObject?.thursdayIsActive || false;
            this.fridayStartTime = jsonObject?.fridayStartTime || '';
            this.fridayEndTime = jsonObject?.fridayEndTime || '';
            this.fridayIsActive = jsonObject?.fridayIsActive || false;
            this.saturdayStartTime = jsonObject?.saturdayStartTime || '';
            this.saturdayEndTime = jsonObject?.saturdayEndTime || '';
            this.saturdayIsActive = jsonObject?.saturdayIsActive || false;
    }
}
